import { render } from "./ExamReport.vue?vue&type=template&id=5fc49557&scoped=true"
import script from "./ExamReport.vue?vue&type=script&lang=js"
export * from "./ExamReport.vue?vue&type=script&lang=js"

import "./ExamReport.vue?vue&type=style&index=0&id=5fc49557&lang=scss&scoped=true"
import "./ExamReport.vue?vue&type=style&index=1&id=5fc49557&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc49557"]])

export default __exports__